import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { SivaService } from 'src/api/v2';

export function useSivaContractDataExtract(year?: number) {
  const [service] = useState(() => new SivaService());

  return {
    downloadAllData: useMutation({
      mutationFn: async (sivaProgramAdmin: boolean) => {
        return await service.getSivaContractsAllData(sivaProgramAdmin, year);
      },
    }),
    downloadKtuData: useMutation({
      mutationFn: async (sivaProgramAdmin: boolean) => {
        return await service.getSivaContractsKtuData(sivaProgramAdmin);
      },
    }),
  };
}
